module.exports = "/_next/static/images/ryuunoko_waiting-e0be5bf54ac32c1b147a347cda703112.jpg";